// Στο αρχείο που ορίζει το context (π.χ., SelectionContext.js)
import React, { createContext, useState, useContext, useEffect } from 'react';

const SelectionContext = createContext();

export const SelectionContextProvider = ({ children }) => {
  const [currentSelection, setCurrentSelection] = useState({
    value: 0,
    label: 'Όλες οι εταιρίες δημοσκοπήσεων',
  });

  useEffect((value) => {
    value && setCurrentSelection(value)
  }, [currentSelection]);

  return (
    <SelectionContext.Provider value={{ currentSelection, setCurrentSelection }}>
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelection = () => {
  return useContext(SelectionContext);
};
